var render, staticRenderFns
import script from "./DatasourceTable.vue?vue&type=script&lang=js&"
export * from "./DatasourceTable.vue?vue&type=script&lang=js&"
import style0 from "./DatasourceTable.vue?vue&type=style&index=0&id=1aa5d86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5d86c",
  null
  
)

export default component.exports